<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card-group deck>
          <b-card>
            <b-skeleton width="85%"></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
            <b-skeleton width="70%"></b-skeleton>
          </b-card>
          <b-card>
            <b-skeleton width="85%"></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
            <b-skeleton width="70%"></b-skeleton>
          </b-card>
          <b-card>
            <b-skeleton width="85%"></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
            <b-skeleton width="70%"></b-skeleton>
          </b-card>
          <b-card>
            <b-skeleton width="85%"></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
            <b-skeleton width="70%"></b-skeleton>
          </b-card>
        </b-card-group>
        <br class="p-5">
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>
    </b-skeleton-wrapper>
    <b-container fluid v-if="!loading">
      <b-overlay :show="refundSending" spinner-medium>

        <div><h1>{{ $t('Batch Refunds') }}</h1></div>
        <b-table
            :items="paginatedRefunds"
            primary-key="id"
            :fields="fields"
            :loading="loading"
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            :error-id="errorId"
            @sort-changed="handleSort"
            hover
            responsive
            :tbody-tr-class="rowClass"
        >

          <template #head()="data">{{ $t(data.label) }}</template>

          <template #cell(checkbox)="data">
            <b-form-checkbox
                :key="data.item.id"
                v-model="selectedIds"
                :value="data.item.id"
                :disabled="blockedIds.includes(data.item.id)"
            />
          </template>

          <template #cell(id)="data">
            <b-link target="_blank" :to="{ name: 'rma', params: { rmaNumber: data.item.rmaNumber } }">
              {{ data.item.id }}
            </b-link>
          </template>

          <template #cell(order)="data">
            <b-link target="_blank" :to="{ name: 'returns', query: { filter: { orderNumber: data.item.order } } }">
              {{ data.item.order }}
            </b-link>
          </template>

          <template #cell(orderProduct)="data">
            {{ data.item.orderProduct }}
          </template>

          <template #cell(operation)="data">
            {{ data.item.operation }}
          </template>

          <template #cell(resolution)="data">
            {{ data.item.resolution }}
          </template>

          <template #cell(status)="data">
            {{ data.item.status }}
          </template>

          <template #cell(condition)="data">
            {{ data.item.condition }}
          </template>

          <template #cell(approvedAmount)="data">
            {{ data.item.approvedRefundAmount }}
          </template>

          <template #cell(currency)="data">
            {{ data.item.currency }}
          </template>

          <template #cell(source)="data">
            {{ data.item.source }}
          </template>

          <template #cell(spedimexQualityReceived)="data">
            {{ data.item.spedimexQualityReceived }}
          </template>

          <template #cell(spedimexQuantityReceived)="data">
            {{ data.item.spedimexQuantityReceived }}
          </template>

          <template #cell(spedimexUpdated)="data">
            {{ data.item.spedimexUpdated }}
          </template>
        </b-table>
        <b-navbar>
          <b-navbar-nav>
            <b-form-checkbox
                v-if="totalRows > 0" type="dark"
                v-model="selectedAll" @change="selectAll"
            >
              {{ $t(' ') }}
            </b-form-checkbox>
            <b-button
                variant="success"
                @click="sendRefunds"
                style="width: 160px;"
                :disabled="selectedIds.length === 0 || refundSending"
            >
              <b-spinner small v-show="refundSending" class="mr-2"></b-spinner>
              <span v-show="!refundSending">{{ $t('Refund') }} ({{ selectedIds.length }})</span>
              <span v-show="refundSending">{{ $t('Refunding...') }}</span>
            </b-button>
          </b-navbar-nav>
          <b-navbar-nav style="margin-left: auto;">
            <span class="pr-3">{{ $t('Shown') }} {{ shown }} {{ $t('from') }} {{ totalRows }}</span>
          </b-navbar-nav>
          <b-navbar-nav>
            <b-pagination
                v-model.number="queryPage"
                :total-rows="totalRows"
                :per-page="queryPerPage"
            ></b-pagination>
          </b-navbar-nav>
          <b-navbar-nav>
            <b-form-select
                v-model.number="queryPerPage"
                :options="listPerPage"
            ></b-form-select>
          </b-navbar-nav>
        </b-navbar>
      </b-overlay>
    </b-container>
  </div>
</template>

<script>
import {getJsonData} from "../services/fetchApi";
import {postJsonData} from "@/services/fetchApi";

const initPage = 1;
const initPerPage = 10;
export default {

  data() {
    return {
      refundSending: false,
      loading: true,
      selectedIds: [],
      selectedAll: false,
      refundedIds: [],
      notRefundedIds: [],
      errorId: '',
      blockedIds: [],
      totalRows: 0,
      listPerPage: [5, 10, 20, 50, 100],
      perPage: 10,
      currentPage: 1,
      allRefunds: [],
      sortBy: 'approvedRefundAmount',
      sortDesc: true,
      fields: [
        { key: 'checkbox', label: '' },
        { key: 'id', label: 'RMA Product Id', tdClass: 'text-nowrap' },
        { key: 'order', label: 'Order Number', tdClass: 'text-nowrap' },
        { key: 'orderProduct', label: 'Product', tdClass: 'text-nowrap' },
        { key: 'operation', label: 'Operation' },
        { key: 'resolution', label: 'Resolution' },
        { key: 'status', label: 'Status' },
        { key: 'condition', label: 'Condition' },
        { key: 'approvedRefundAmount', label: 'Approved Amount', sortable: true },
        { key: 'currency', label: 'Currency' },
        { key: 'source', label: 'Source' },
        { key: 'spedimexQualityReceived', label: 'Spedimex Quality' },
        { key: 'spedimexQuantityReceived', label: 'Spedimex Quantity' },
        { key: 'spedimexUpdated', label: 'Spedimex Updated', sortable: true }
      ]
    }
  },
  methods: {
    rowClass(item) {
      if (this.refundedIds.includes(item.id)) {
        return 'table-success';
      }
      else if (this.errorId === item.id) {
        return 'table-danger';
      }
      else if (this.notRefundedIds.includes(item.id)) {
        return 'table-warning';
      }
      return '';
    },

    selectAll() {
      const availableIds = this.currentPageIds.filter(id => !this.blockedIds.includes(id));
      if (this.selectedAll) {
        this.selectedIds = [...new Set([...this.selectedIds, ...availableIds])];
      } else {
        this.selectedIds = [];
      }
    },

    sendRefunds(e) {
      e.preventDefault();
      const $this = this;
      if ($this.refundSending) {
        return false;
      }
      $this.refundSending = true;
      $this.$store.commit('setLoadingAnything', true);
      $this.refundErrors = null;
      this.blockedIds = this.blockedIds.concat(this.selectedIds || []);
      postJsonData(
          this.getActionUrl.sendRefunds,
          JSON.stringify({
            refundIds: this.selectedIds
          }),
      )
          .then(json => {
            const response = JSON.parse(json);
            this.refundedIds = this.refundedIds.concat(response.refundedIds || []);
            this.notRefundedIds = response.notRefundedIds ?? [];
            this.errorId = response.errorId ?? '';
            if(response.errorMessage) {
              $this.$store.commit('showToast', {
                message: response.errorMessage,
                title: $this.$t('Batch Refunds'),
                type: 'danger'
              });
            }
          })

          .catch(error => {
            let message = $this.$t('Can not process refunds') + ':' + (error ?? $this.$t('Unknown error'));
            $this.$store.commit('showToast', {
              message: message,
              title: $this.$t('Batch Refunds'),
              type: 'danger'
            });
            $this.refundErrors = [message];
          })
          .finally(() => {
            this.selectedIds = [];
            this.selectedAll = [];
            $this.refundSending = false;
            $this.$store.commit('setLoadingAnything', false);
          });
      return false;
    },
    fetchRefunds() {
      this.loading = true;
      getJsonData(this.getActionUrl.getRefunds)
          .then(json => {
            this.allRefunds = json.common;
            this.totalRows = json.common.length;
          })
          .catch(error => {
            this.$store.commit('showToast', {
              message: error,
              title: this.$t('Can not load list of Refunds'),
              type: 'danger'
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    handleSort(ctx) {
      if (this.sortBy === ctx.sortBy) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = ctx.sortBy;
        this.sortDesc = ctx.sortDesc;
      }
    },
  },
  computed: {
    currentPageIds() {
      return this.paginatedRefunds.map(item => item.id);
    },
    sortedRefunds() {
      if (!this.sortBy || this.allRefunds === undefined || this.allRefunds.length === 0) return this.allRefunds;

      return [...this.allRefunds].sort((a, b) => {
        const aVal = a[this.sortBy];
        const bVal = b[this.sortBy];

        if (aVal == null) return 1;
        if (bVal == null) return -1;

        if (typeof aVal === 'number' && typeof bVal === 'number') {
          return this.sortDesc ? bVal - aVal : aVal - bVal;
        }

        return this.sortDesc
            ? String(bVal).localeCompare(String(aVal))
            : String(aVal).localeCompare(String(bVal));
      });
    },
    paginatedRefunds() {
      const list = this.sortedRefunds || [];
      const start = (this.queryPage - 1) * this.queryPerPage;
      const end = start + parseInt(this.queryPerPage);
      return list.slice(start, end);
    },

    shown() {
      return this.paginatedRefunds.length;
    },
    getActionUrl: function () {
      return {
        getRefunds: process.env.VUE_APP_BACKEND_SERVER + 'api/refunds/batch_refund_list',
        sendRefunds: process.env.VUE_APP_BACKEND_SERVER + 'api/refunds/send_batch_refunds'
      }
    },
    queryPage: {
      get() {
        return this.$route.query.page ?? initPage;
      },
      set(val) {
        if (val === this.queryPage) {
          return;
        }
        this.$router
            .push({
              query: {
                ...this.$route.query,
                page: val
              }
            })
            .catch();
      }
    },
    queryPerPage: {
      get() {
        return this.$route.query.perPage ?? initPerPage;
      },
      set(val) {
        if (val === this.queryPerPage) {
          return;
        }
        this.$router
            .push({
              query: {
                ...this.$route.query,
                perPage: val
              }
            })
            .catch();
      }
    },
  },
  created() {
    this.fetchRefunds();
  },
  watch:{
    queryFilter() {
      this.initFilterForm()
    },

    paginatedRefunds() {
      this.selectedIds = this.selectedIds.filter(id => this.currentPageIds.includes(id));
      this.selectedAll = false;
    },
  },
}
</script>